import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar, { scrollToHash } from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Episodes from "@/components/Episodes";
import BubzPlus from "@/components/BubzPlus";
import Creator from "@/components/Creator";
import FunZone from "@/components/FunZone";
import Footer from "@/components/Footer";
import BubblePop from "@/pages/BubblePop";
import Coloring from "@/pages/Coloring";

function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToHash(location.state.scrollTo), 250);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Episodes />
      <BubzPlus />
      <Creator />
      <FunZone />
    </main>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App overflow-x-hidden bg-bubz-cream font-body text-bubz-ink">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/game" element={<BubblePop />} />
          <Route path="/coloring" element={<Coloring />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
